import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectAppIsLoading = (store: StoreSchema) => store.application.isLoading